import { useKitsData } from "@/data/use-kits-data";
import { useIsApiReady } from "@/hooks/use-api-ready";
import { groupKitExpertControllerGetExperts } from "@/lib/gen-api";
import { queryKeys } from "@/lib/query-keys";
import { useQueries } from "@tanstack/react-query";

export const useGroupKitExpertsData = (groupUuid: string | null) => {
  const isApiReady = useIsApiReady();
  const { kits: expertKits } = useKitsData(groupUuid, { type: "expert" });

  const results = useQueries({
    queries: expertKits.map((kit) => ({
      enabled: isApiReady && !!groupUuid,
      queryKey: queryKeys.kitExperts(groupUuid!, kit.uuid),
      queryFn: () =>
        groupKitExpertControllerGetExperts({
          path: { groupUuid: groupUuid!, kitUuid: kit.uuid },
        }).then((res) =>
          (res.data?.data ?? []).map((expert) => ({
            ...expert,
            expertKitUuid: kit.uuid,
          })),
        ),
    })),
  });

  const experts = results.flatMap((r) => r.data ?? []);

  return { experts };
};
